import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, ButtonToolbar, Button, Spinner } from 'reactstrap';
import { Field } from 'react-final-form';
import MuiButton from '@material-ui/core/Button';
import SwitchField from '@/shared/components/form/Switch';
import Select from "react-select";
import FormCsvField from "./FormCsvField";
import SetupFields from "./SetupFields";
import getCsvImportSettings from '@/services/getCsvImportSettings';
import {connect} from "react-redux";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const FormStep2 = ({ config, csvFile, setCsvFile, onclickBack, importHeaders, isValidResponse, setSaveSettings, saveSettings, handleSubmit, organization, csvImportType, program, processing, processingImport, form, importId, makeOptions, savedSettings, onFieldChange }) => {
    const [checked, setChecked] = useState(false);
    const [typeChanged, setTypeChanged] = useState(false);
    const [customSubmit, setCustomSubmit] = useState(false);
    const switchHandler = () => {
        setChecked(!checked);
    };

    useEffect(() => {
        if (organization?.id) {
            if (typeChanged !== false){
                getCsvImportSettings(organization.id, program.id, csvImportType.id)
                  .then(data => {
                      setTypeChanged(false);
                  })
            }
        }
    }, [organization, typeChanged, savedSettings])

    if (!importHeaders) return 'Loading...'
    const fieldsToMap = makeOptions(importHeaders.fieldsToMap);

    const fieldMapping = importHeaders?.fieldMapping;
    const formatOptionLabel = ({ label, description }) => (
        <div>
            <div>{label}</div>
            {description && (
                <div style={{ fontSize: '12px' }}>
                    {description}
                </div>
            )}
        </div>
    );
    return (
        <div className="form-step2">
            <div className="form__form-group">
                {importHeaders.hasOwnProperty("setups") &&
                    <SetupFields setups={importHeaders.setups} setupsFull={importHeaders.setupsFull} setTypeChanged={setTypeChanged}
                                 savedSettings={savedSettings} typeChanged={typeChanged} csvImportType={csvImportType}  />
                }
                {importHeaders.hasOwnProperty("Userroles") && <Row>
                    <Col md="3">
                        <h5>User Role</h5>
                    </Col>
                    <Col md="9" lg="7" xl="5" >
                        <Field name={config.userRole.name}>
                            {({ input, meta }) => (
                                <div>
                                    <Select
                                        options={config.userRole.options}
                                        clearable={false}
                                        className="react-select"
                                        placeholder={config.userRole.placeholder}
                                        classNamePrefix="react-select"
                                        {...input}
                                    />
                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>}
                {importHeaders.hasOwnProperty("Emailusers") && <Row>
                    <Col md="3">
                        <h5>Email User?</h5>
                    </Col>
                    <Col md="9" lg="7" xl="5" >
                        <Field name="email_user">
                            {({ input, meta }) => (
                                <div>
                                    <SwitchField checked={checked} name={input.name} onClick={switchHandler} />
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>}
                {isValidResponse(importHeaders) &&
                    <>
                        <Row>
                            <Col md="12">
                                <h4 className="mb-3 d-flex align-items-center">
                                Field Mapping

                                    <Tooltip
                                        title="Match CSV columns to system fields. Ensure each required field is correctly mapped before importing."
                                        arrow
                                        placement="right"
                                    >
                                        <IconButton size="small" style={{ padding: 4, marginLeft: 6 }}>
                                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                                        </IconButton>
                                    </Tooltip>
                                </h4>
                            </Col>
                        </Row>
                        {importHeaders.CSVheaders.map((field, index) => <div key={index}>
                            <FormCsvField {... { field, fieldsToMap, savedSettings, typeChanged, fieldMapping, formatOptionLabel, form, onFieldChange }} />
                        </div>)}
                        <br />
                    </>
                }
                <Field
                  name="isSaveSettings"
                  component="input"
                  type="hidden"
                  placeholder="Last Name"
                  initialValue={saveSettings}
                />
                <div className="form__form-group-field flex-column" style={{width: 'fit-content'}}>
                    <div className="form__form-group-row flex-row pt-3">
                        <Button className="btn btn-outline-primary btn-sm" color="#ffffff"  onClick={onclickBack} style={{}}>Back</Button>
                        <Button onClick={(e) => {
                            setSaveSettings(true);
                        }} className="btn btn-primary btn-sm" color="#ffffff" type="submit" style={{}} >
                            {processing ? (
                                <>
                                    <Spinner size="sm" style={{ marginRight: 8 }} />
                                    saving...
                                </>
                            ) : (
                                'Save Settings'
                            )}
                        </Button>
                    </div>
                    <div className="form__form-group-row flex-row pt-3 ">
                        <Button onClick={(e) => {
                            // e.preventDefault();
                            if (processingImport) return;
                            setSaveSettings(false);
                            // setCustomSubmit(true);
                        }} className="btn btn-primary btn-sm w-100" color="#ffffff"  type="submit" style={{}}>
                            {processingImport ? (
                                <>
                                    <Spinner size="sm" style={{ marginRight: 8 }} />
                                    Importing...
                                </>
                            ) : (
                                'Import'
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
  return {
    program: state.program,
    organization: state.organization,
  };
};
export default connect(mapStateToProps)(FormStep2);

// export default connect((state) => ({
//     organization: state.organization,
//     program: state.program
// })(FormStep2));

